import { render } from "./JoinFirst.vue?vue&type=template&id=3509c155&scoped=true"
import script from "./JoinFirst.vue?vue&type=script&lang=js"
export * from "./JoinFirst.vue?vue&type=script&lang=js"

import "./JoinFirst.vue?vue&type=style&index=0&id=3509c155&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3509c155"]])

export default __exports__